/* eslint no-console: off, no-restricted-globals: off */

// Import polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import angular from 'angular'
import * as Sentry from '@sentry/browser'

import constants from './constants'
import app from './app'

import packageJson from '../package'
import * as versionHelpers from '../shared/version-helpers'

const initInjector = angular.injector(['ng'])
const $http = initInjector.get('$http')

function setupRaven (configuration) {
  if (configuration.sentry.dsn) {
    Sentry.init({
      dsn: configuration.sentry.dsn,
      environment: configuration.targetEnv,
      release: versionHelpers.getStringified(packageJson.jumbotron.build),
      integrations: [
        Sentry.browserTracingIntegration()
      ],
      // Set tracesSampleRate to 1.0 to capture 100% of transactions
      tracesSampleRate: 1.0
    })

    // Add Angular integration
    window.onerror = function (message, source, lineno, colno, error) {
      // Get the current digest cycle's context
      const $rootScope = angular.element(document.body).injector().get('$rootScope')
      const context = {}

      // Add relevant scope data from Angular
      Object.keys($rootScope).forEach(key => {
        if (key.charAt(0) !== '$' && key.charAt(0) !== '_') {
          context[key] = $rootScope[key]
        }
      })

      Sentry.withScope(scope => {
        scope.setExtra('angularContext', context)
        Sentry.captureException(error || new Error(message))
      })
    }
  } else {
    console.warn('Sentry not configured')
  }
}

angular.module('bootstrap', []).run(() => {
  // Simple delay function
  const chill = ms => new Promise(resolve => setTimeout(resolve, ms))

  async function loadConfiguration () {
    const descriptionElement = angular.element(document.querySelectorAll('#appLoader > span'))
    descriptionElement.text('Loading configuration')

    // Load configuration from server with exponential backoff
    let configuration
    let delay = 500
    for (;;) {
      try {
        configuration = await $http.get('/config.json')
        configuration = configuration.data
        break
      } catch (e) {
        console.warn('Loading configuration failed', e)

        delay = Math.min(delay * 2, 30000)

        await chill(delay)
      }
    }

    // Configuration loaded
    descriptionElement.text('Configuration loaded')
    constants.constant('CONFIGURATION', configuration)

    setupRaven(configuration)

    // Bootstrap main application
    const bootstrapAppElement = angular.element(document.querySelectorAll('#bootstrapApp'))
    const appElement = angular.element(document.querySelectorAll('#app'))

    bootstrapAppElement.css('display', 'none')
    appElement.css('visibility', 'visible')

    angular.bootstrap(appElement, [app.name], {
      strictDi: true
    })
  }

  loadConfiguration()
})
